import presentationsApi from '@/api/presentations'

const presentations = {
  namespaced: true,
  actions: {
    async unlinkPresentations(_, { presentationIds, email, userId, options }) {
        try {
            const response = await presentationsApi.unlinkPresentation({ presentationIds, email, userId, options })
            return response
        } catch (error) {
            console.error(error)
            throw error
        }
    }
  },
}

export default presentations